export const findServerData = [
  {
    //Eustác
    id: 0,
    path: [
      "199.38.67.227",
      "155.177.229.194",
      "34.239.245.172",
      "60.40.118.216",
      "81.119.95.47",
      "34.239.245.172",
      "99.133.116.181",
    ],
    content: "Ahoj, ja",
    from: "199.38.67.227",
    to: "99.133.116.181",
    speed: 30,
  },
  {
    //Kiara
    id: 1,
    path: [
      "104.169.110.92",
      "81.119.95.47",
      "34.239.245.172",
      "60.40.118.216",
      "203.212.60.217",
      "155.177.229.194",
      "199.38.67.227",
    ],
    content: "ky, dobř",
    from: "104.169.110.92",
    to: "199.38.67.227",
    speed: 30,
  },
  {
    //Annika
    id: 2,
    path: [
      "60.150.25.71",
      "81.119.95.47",
      "60.40.118.216",
      "155.177.229.194",
      "203.212.60.217",
      "5.10.40.25",
    ],
    content: "zína, př",
    from: "60.150.25.71",
    to: "5.10.40.25",
    speed: 30,
  },
  /* {
    //random
    id: 3,
    path: ["2001:718:1202:240::201", "45.87.28.93", "2001:718:1e05:604::50"],
    content: "vka je m",
    from: "185.158.64.12",
    to: "2001:718:1e05:604::50",
    speed: 30,
  },*/
  /* {
    //random
    id: 4,
    path: [
      "77.75.79.138",
      "147.32.3.202",
      "91.198.174.192",
      "82.208.6.9",
      "57.200.0.1",
    ],
    content: "na obědě",
    from: "77.75.79.138",
    to: "195.113.89.35",
    speed: 30,
  },*/
];
